import io from "socket.io-client";

//const BASE_URLP = import.meta.env.VITE_URL;
//const socketon = io.connect(BASE_URLP);

const base = import.meta.env.BASE_URL;

const socketon = io(window.location.origin, {
  path: `${base}socket.io`,
  transports: ["polling"], //analizar
  upgrade: false
});

const socketoff = () => {
  return io.disconnect();
};

export { socketon, socketoff };
